const mockCategories = [
  // Handformen
  { id: 1, name: "Tan Tui", type: "Handform", ageGroups: ["Kinder", "Senioren Plus"] },
  { id: 2, name: "Gong Li Quan", type: "Handform", ageGroups: ["Jugend", "Kinder", "Senioren", "Senioren Plus"] },
  { id: 3, name: "Qing Long Quan", type: "Handform", ageGroups: ["Senioren", "Senioren Plus"] },
  { id: 4, name: "Shi Zi Zhan", type: "Handform", ageGroups: ["Kinder", "Senioren Plus"] },
  { id: 5, name: "Huo Mizong", type: "Handform", ageGroups: ["Jugend", "Kinder", "Senioren", "Senioren Plus"] },
  { id: 6, name: "Dang Quan", type: "Handform", ageGroups: ["Erwachsene", "Jugend", "Kinder", "Senioren", "Senioren Plus"] },
  { id: 7, name: "Beng Bu Quan", type: "Handform", ageGroups: ["Erwachsene", "Jugend", "Senioren", "Senioren Plus"] },
  { id: 8, name: "Da Zhan Quan", type: "Handform", ageGroups: ["Erwachsene", "Jugend", "Kinder", "Senioren"] },
  { id: 9, name: "Da Mian Zhang", type: "Handform", ageGroups: ["Erwachsene", "Jugend"] },
  { id: 10, name: "San Quan", type: "Handform", ageGroups: ["Erwachsene"] },
  { id: 11, name: "Jie Quan", type: "Handform", ageGroups: ["Erwachsene"] },
  { id: 12, name: "Yang Jia Shou", type: "Handform", ageGroups: ["Erwachsene"] },
  { id: 13, name: "Mi Zong Tou Lu Quan", type: "Handform", ageGroups: ["Erwachsene", "Jugend", "Senioren"] },
  { id: 14, name: "Yi Lu Sha Shou Zhang", type: "Handform", ageGroups: ["Jugend", "Kinder", "Senioren", "Senioren Plus"] },

  // Waffenformen
  { id: 100, name: "Ba Gua Dao", type: "Waffenform", ageGroups: ["Kinder", "Senioren", "Senioren Plus"] },
  { id: 101, name: "Qun Yang Gun", type: "Waffenform", ageGroups: ["Jugend", "Kinder", "Senioren Plus"] },
  { id: 102, name: "Lu Hua Gun", type: "Waffenform", ageGroups: ["Erwachsene", "Jugend", "Kinder", "Senioren", "Senioren Plus"] },
  { id: 103, name: "San Guang Jian", type: "Waffenform", ageGroups: ["Erwachsene", "Jugend", "Kinder", "Senioren", "Senioren Plus"] },
  { id: 104, name: "Wu Hu Qiang", type: "Waffenform", ageGroups: ["Kinder", "Senioren", "Senioren Plus"] },
  { id: 105, name: "Xue Pian Dao", type: "Waffenform", ageGroups: ["Erwachsene", "Jugend", "Kinder"] },
  { id: 106, name: "Lu Hua Dao", type: "Waffenform", ageGroups: ["Erwachsene", "Jugend", "Senioren"] },
  { id: 107, name: "Damo Jian", type: "Waffenform", ageGroups: ["Erwachsene", "Jugend", "Senioren", "Senioren Plus"] },
  { id: 108, name: "Zhang Jia Qiang", type: "Waffenform", ageGroups: ["Erwachsene"] },
  { id: 109, name: "Liu He Qiang", type: "Waffenform", ageGroups: ["Erwachsene", "Jugend"] },
  { id: 110, name: "Qi Men Gun", type: "Waffenform", ageGroups: ["Senioren"] },
  { id: 111, name: "Chun Qiu Da Dao", type: "Waffenform", ageGroups: ["Erwachsene", "Senioren"] },
  { id: 112, name: "Bao Yue Dao", type: "Waffenform", ageGroups: ["Senioren Plus"] },

  // Offene Formen
  { id: 201, name: "Offene Handform", type: "Offene Form", ageGroups: ["Erwachsene", "Jugend", "Kinder", "Senioren", "Senioren Plus"] },
  { id: 202, name: "Offene Waffenform", type: "Offene Form", ageGroups: ["Erwachsene", "Jugend", "Kinder", "Senioren", "Senioren Plus"] },

  // Partnerformen
  { id: 300, name: "Jie Tan Tui", type: "Partnerform", ageGroups: ["Erwachsene", "Jugend", "Kinder", "Senioren", "Senioren Plus"] },
  { id: 301, name: "Tao Quan", type: "Partnerform", ageGroups: ["Erwachsene", "Jugend", "Senioren"] }
];

export default mockCategories;
